exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3ZPrJgvD9D0OLg{z-index:20;position:absolute;top:38px;right:8px;padding:16px;width:320px;border-radius:3px;background-color:#fff;box-shadow:0 8px 16px -4px rgba(9,45,66,.25),0 0 0 1px rgba(9,45,66,.08)}._3ZPrJgvD9D0OLg:after{bottom:100%;right:29px;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none;border-bottom-color:#fff;border-width:8px;margin-left:-4px}._3DATH58YHQrpC-{text-align:left;text-decoration:underline;color:#5e6c84;margin:0;padding:0}", ""]);

// exports
exports.locals = {
	"pupTooltip": "_3ZPrJgvD9D0OLg",
	"pupTooltipDismiss": "_3DATH58YHQrpC-"
};